import React from 'react';
import { ChakraProvider, theme} from '@chakra-ui/react';
import { AuthProvider } from 'react-auth-kit'
import RoutesComponent from './Routes';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
// import refreshApi from "./refreshApi";

const queryClient = new QueryClient()

function App() {
  return (
    <AuthProvider authType = {'cookie'} authName={'_auth'} 
    // refresh={refreshApi}
    >
      <ChakraProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <RoutesComponent/>
        </QueryClientProvider>
      </ChakraProvider>
    </AuthProvider>
  );
}

export default App;
